export const searchDatasets = "searchDatasets";
export const searchCustomDatasets = "searchCustomDatasets";
export const searchAdminCustomDatasets = "searchAdminCustomDatasets";
export const searchAdminDatasets = "searchAdminDatasets";
export const optOutMfa = "optOutMfa";
export const clipManagementColumnVisibility = "clipManagement_columnVisibility";
export const opportunitiesData = "opportunities_data";
export const opportunitiesColumnVisibility = "opportunities_columnVisibility";
export const homeLayoutV3 = "home_layout_v3";
export const verifyWaitlistSubmitted = "verifyWaitlistSubmitted";
export const planningInsightsBannerDismissed = "planningInsightsBannerDismissed";
export const catalogueView = "catalogue_view";
